import React from 'react';
import { 
    translate,
    List, 
    Datagrid,
    TextField, 
    DateField,
    EditButton,
    ShowButton,
    ListButton,
    Show,
    CardActions,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import classnames from 'classnames';
import jwt_decode from 'jwt-decode'
import LinkToCreate from './LinkToCreate'



const styles = {
    inlineBlock: { display: 'inline-flex', marginRight: '1rem' },
};


const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const listStyles = {
    actions: {
        backgroundColor: 'Lavender',
    },
    header: {
        backgroundColor: '#def',
        fontWeight: 'bold',
    },
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const ProcessingActions = ({...props}) => (

    <CardActions style={cardActionStyle}>
        <LinkToCreate ssn={props.filterValues.ssn} />
        <ListButton basePath={'/donors'} label="Donors List" />
    </CardActions>
);





export const AbscList = ({ classes, permissions, ...props }) => (
  
    <List 
        classess={classes}
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<ProcessingActions/>} 
        title="ABSC Tracking"
        >
        
        <Datagrid  classes={{ headerCell: classes.header }} >     
            <DateField source="collect_date"    label="Date of Collection" locales="en-us"/>
            <DateField source="next_date"    label="Next due Date" locales="en-us"/>
            <TextField source="tech_init"     label="Tech Initial" />
            <TextField source="qa_init"     label="QA Initial" />
            <DateField source="qa_date"    label="QA Date" locales="en-us"/>
            {(((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).level : 0 ) > 3  &&  <EditButton label="Update" />}
        </Datagrid>
    </List>
);


export default withStyles(listStyles)(AbscList)